// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YahooOutlinedSvg from "@ant-design/icons-svg/es/asn/YahooOutlined";
import AntdIcon from '../components/AntdIcon';

var YahooOutlined = function YahooOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: YahooOutlinedSvg
  }));
};

YahooOutlined.displayName = 'YahooOutlined';
export default React.forwardRef(YahooOutlined);